<template>
  <div class="wifi-check">
    <h2>请连接至WIFI</h2>
    <p>SSID: smartsport</p>
    <p>密码: 12345678</p>
    <p>连接完成后，请点击刷新按钮</p>
    <!-- <frosted-card>
      <h3>设备状态</h3>
      <p>当前项目：{{ currentProject }}</p>
      <van-button type="primary" block>开始测试</van-button>
    </frosted-card> -->

     <van-field v-model="serveIp" label="服务地址" placeholder="请输入服务地址" />
 <div style="margin-top: 10px;">
     <van-button style="width: 100px;" type="default" @click="checkNetwork" v-show="!isConnected">刷新</van-button>
     <!--  -->
    <van-button style="width: 100px;" type="default" @click="toNext" v-show="isConnected">下一步</van-button>
 </div>
  </div>
</template>

<script>
import FrostedCard from '@/components/FrostedCard.vue'
import req from '@/utils/request2.js';
 
export default {
    components: { FrostedCard },
  name: 'WiFiCheck',
  data () {
    return {
        isConnected:false,
        serveIp:"https://192.168.50.92:18086"
        // 116.62.214.157:12001
    }
  },
  methods: {
    async checkNetwork() {
      // 模拟网络检测（实际项目替换为真实接口）
      try {
        // 假设这里调用一个服务接口
        await this.jiekou() // 示例，需替换

        localStorage.setItem('outdoorRunnControlData',JSON.stringify
        ({
          serveIp:this.serveIp
        }))
        
        this.$toast.success('网络已连通！')
        this.isConnected = true
      } catch (err) {
        this.$toast.fail('未连接到指定网络，请重试')
      }
    },
    async jiekou(){
        // let data = {}
       await req.post({
          url:`${this.serveIp}/status`,
          data:{},
        }).then(res=>{
        this.$toast('操作成功');

        })
    },
    toNext(){
        this.$router.push({
          path:'/outdoorRunning/SelectVenue',
          query:{
            serveIp:this.serveIp
          }
        })
    }
  }
}
</script>

<style scoped>
.wifi-check {
  height: calc(100% - 40px);
  padding: 20px;
  text-align: center;
  background-color: #fff;
}
</style>